// What Genie is told about the logged-in user.
export function currentUserContext(user: {
  display_name: string;
  email: string;
  is_admin: boolean;
}) {
  return {
    name: user.display_name,
    email: user.email,
    is_admin: user.is_admin,
    // Schedules run in UTC: Genie converts the user's times from this zone.
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}
